export default __webpack_public_path__ + "static/media/L.2a337f4c.svg";